exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assemblycont[data-v-05e1ce8d]{position:relative;min-height:700px}.assemblycontzzc[data-v-05e1ce8d]{position:absolute;top:0;right:0;left:0;bottom:0;background:#fff}.assemblycont_item[data-v-05e1ce8d]{background:#f1f2fd;display:flex;justify-content:center;align-items:center;height:40px;margin-bottom:10px;box-sizing:border-box;transition:.3s;cursor:pointer;cursor:move;font-size:14px}.assemblycont_item[data-v-05e1ce8d]:hover{border:1px dashed #579ff8;color:#579ff8;transition:.3s}.imgclass[data-v-05e1ce8d]{width:200px;height:200px}.lajitongdiv[data-v-05e1ce8d]{position:absolute;top:0;right:0;left:0;bottom:0;display:flex;justify-content:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05e1ce8d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/plugin/assembly.vue
// module id = 24
// module chunks = 0